import {
  MeshBasicMaterial,
  Mesh,
  DoubleSide,
  AlwaysStencilFunc,
  ReplaceStencilOp,
  EqualStencilFunc,
  KeepStencilOp,
  Object3D,
  PlaneGeometry,
  Color,
  TextureLoader,
} from "three";
import { VBase } from "./VBase";
import VUtil from "../VUtils";
import { VSlider2 } from "./_VSlider2";
import { Line2 } from "three/examples/jsm/lines/Line2.js";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry.js";
import { VButton } from "./_VButton";

const defaultOptions = {
  data: [
    {
      children: [
        {
          children: [],
          id: 2,
          text: "层3",
        },
        {
          children: [{ children: [], id: 5, text: "层5" }],
          id: 3,
          text: "层4",
        },
      ],
      id: 0,
      text: "层1",
    },
    { children: [], id: 1, text: "层2" },
  ],
  dataTextName: "text",
  dataUniqueName: "id",
  dataChildrenName: "children",
  color: 0x999999,
  opacity: 1.0,
  map: null,
  radius: 0.03,
  textSize: 0.03,
  textColor: 0x000000,
  font: "normal",
  width: 0.5,
  height: 0.7,
  disabledColor: 0xc8c8c8,
  padding: 0.03,
  itemHeight: 0.05,
  itemOffset: 0.005,
  itemColor: 0xffff00,
  itemSelectColor: 0x00ffff,
  itemSelectOpacity: 0.5,
  itemOpacity: 0.01,
  itemBgMap: null,
  visibleBtnIcon: null,
  unFolder: true,
  sliderColor: 0xffffff,
  handleColor: 0x00ffff,
};

/*
  使用案例

      const itemBgPath = "/assets/vrUI/hierarchyPanel/itemBg.png";
      const visibleIconPath = "/assets/vrUI/hierarchyPanel/visible.png";
      const hideIconPath = "/assets/vrUI/hierarchyPanel/hide.png";
      const visibleIcon = await this.manager.loadManager.loadTexture(
        visibleIconPath
      );
      const hideIcon = await this.manager.loadManager.loadTexture(hideIconPath);
      const itemBg = await this.manager.loadManager.loadTexture(itemBgPath);

      // tree
      const tree = this.uiLib.createTree({
        data: [
          {
            id: "1",
            text: "根节点",
            children: [
              {
                id: "2",
                text: "科技发展",
                children: [
                  {
                    id: "3",
                    text: "人工智能",
                    children: [
                      {
                        id: "4",
                        text: "机器学习",
                        children: [
                          {
                            id: "5",
                            text: "深度学习",
                            children: [],
                          },
                          {
                            id: "6",
                            text: "强化学习",
                            children: [],
                          },
                        ],
                      },
                      {
                        id: "7",
                        text: "自然语言处理",
                        children: [
                          {
                            id: "8",
                            text: "文本分类",
                            children: [],
                          },
                          {
                            id: "9",
                            text: "机器翻译",
                            children: [],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: "10",
                    text: "区块链",
                    children: [
                      {
                        id: "11",
                        text: "加密货币",
                        children: [
                          {
                            id: "12",
                            text: "比特币",
                            children: [],
                          },
                          {
                            id: "13",
                            text: "以太坊",
                            children: [],
                          },
                        ],
                      },
                      {
                        id: "14",
                        text: "智能合约",
                        children: [
                          {
                            id: "15",
                            text: "Solidity",
                            children: [],
                          },
                          {
                            id: "16",
                            text: "DeFi",
                            children: [],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
        dataTextName: "text",
        dataUniqueName: "id",
        dataChildrenName: "children",
        width: 0.8,
        height: 1,
        radius: 0,
        color: 0x000000,
        opacity: 0.8,
        textColor: 0xa8b4db,
        textSize: 0.045,
        padding: 0,
        itemHeight: 0.1,
        itemOffset: 0,
        itemBgMap: itemBg,
        font: "bold",
        sliderColor: "#252C3C",
        handleColor: "#8993C3",
        itemSelectColor: 0xffff00,
        itemSelectOpacity: 0.5,
        visibleBtnIcon: [visibleIcon, hideIcon],
        visibleBtnStateChangeColor: {
          normal: 0xffffff,
          hover: 0xafbbe3,
          click: 0x3d4146,
        },
      });
      // 注册光标进入树节点事件
      tree.addOnElementHoverEnterEvent((obj) => {
        if (obj._text) VUtil.setTextColor(obj._text, "#6275B5");
      });
      // 注册光标离开树节点事件
      tree.addOnElementHoverExitEvent((obj) => {
        if (obj._text) VUtil.setTextColor(obj._text, "#a8b4db");
      });
      // 注册点击树节点显示隐藏按钮事件
      tree.addOnVisibleBtnClickEvent((info, visible) => {
        console.log("点击显示隐藏按钮", info, visible);
        this.manager.interface.getNodeVisibleorUnvisible(info.id, visible);
      });
      // 注册点击树节点事件
      tree.addOnElementClickEvent((data) => {
        console.log("点击了树节点，数据为", data);
      });
      this.uiLib.addUIToScene(tree);

      setTimeout(() => {
        // 增加新节点
        tree.addContent(
          [
            {
              id: "100",
              text: "起始点",
              children: [
                {
                  id: "101",
                  text: "自然科学",
                  children: [
                    {
                      id: "102",
                      text: "物理学",
                      children: [
                        {
                          id: "103",
                          text: "量子力学",
                          children: [],
                        },
                        {
                          id: "104",
                          text: "相对论",
                          children: [],
                        },
                      ],
                    },
                    {
                      id: "105",
                      text: "化学",
                      children: [
                        {
                          id: "106",
                          text: "有机化学",
                          children: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  id: "107",
                  text: "人文社科",
                  children: [
                    {
                      id: "108",
                      text: "历史学",
                      children: [
                        {
                          id: "109",
                          text: "古代史",
                          children: [],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
          "1"
        );
        // 根据id移除节点
        tree.removeContent("14");
        // 展开指定id的节点
        tree.unfolderNode("1", true);
      }, 1000);


      setTimeout(() => {
        // 跳到指定id的节点
        tree.jumpToNode("103", true);
      }, 2000);


*/
export class VTree extends VBase {
  /**
   * options:
   * {
   *      priority: 优先级，默认为1，值越小越靠前
   *      renderOrder: 渲染顺序，默认为99989
   *      data: 内容，[{children:[...],id:0,text:"层1"},{children:[...],id:0,text:"层2"}, ...]
   *      dataTextName: 数据中的文本字段名称，如"name"/"text"等，默认为"text"
   *      dataUniqueName: 数据中的唯一性字段名称，如"index"/"id"等，若数据中没有唯一性字段，此字段设置为null，有些功能将无法使用，默认为'id'
   *      dataChildrenName: 数据中定义孩子节点数组的字段名称，如"children"/"child"等，默认为"children"
   *      color: 背景颜色。默认为 0x999999
   *      opacity: 背景透明度，默认为1
   *      map: 背景贴图，默认为null
   *      textSize: 文字大小，默认为 0.03
   *      textColor: 文字颜色，默认为 0x000000
   *      font: 字体样式，默认为 "normal"  "bold"
   *      width: 背景宽度，默认为 0.5
   *      height: 背景高度，默认为 0.7
   *      padding: 四周的空隙，默认为0.02
   *      itemHeight: 单个节点高度，默认为0.08
   *      itemOffset: 节点与节点间的间隙，默认为0.01
   *      itemColor: 节点的背景色，默认为0xffff00
   *      itemSelectColor: 选中的节点背景色，默认为0x00ffff
   *      itemSelectOpacity: 选中的节点透明度，默认为0.5
   *      itemOpacity: 节点的背景透明度，默认为0
   *      itemBgMap: 节点的背景图，默认为null
   *      visibleBtnIcon: 显示隐藏按钮图标，默认为null，设置了才会显示按钮,需要设置一个数组，包含显示和隐藏图标
   *      visibleBtnStateChangeColor: 显示隐藏按钮状态改变时的颜色对象，可以包含3个状态（"normal","hover","click"）也可以只设置其中某些状态,默认为null
   *      radius: 圆角半径，设为0则是矩形，默认为0.01
   *      sliderColor: 滑动条背景色，默认为 0xffffff
   *      handleColor: 滑动条handle颜色，默认为 0x00ffff
   *      unFolder: 默认是否全部展开树结构的子节点，设置为false将不会自动显示子节点，默认为true
   *      onClickVisible: 点击显示按钮事件（如果设置了显示按钮）
   *      disabledColor:  ui对象禁用颜色，默认为 0xC8C8C8
   *      enabledCb: 设置ui对象enable的回调函数，参数为ui对象本身和enable状态，默认为null
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      priority: options.priority !== undefined ? options.priority : 1,
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99989,
      data: options.data ? options.data : defaultOptions.data,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      padding:
        options.padding !== undefined
          ? options.padding
          : defaultOptions.padding,
      dataTextName: options.dataTextName
        ? options.dataTextName
        : defaultOptions.dataTextName,
      dataUniqueName: options.dataUniqueName
        ? options.dataUniqueName
        : defaultOptions.dataUniqueName,
      dataChildrenName: options.dataChildrenName
        ? options.dataChildrenName
        : defaultOptions.dataChildrenName,
      textSize:
        options.textSize !== undefined
          ? options.textSize
          : defaultOptions.textSize,
      textColor:
        options.textColor !== undefined
          ? options.textColor
          : defaultOptions.textColor,
      font: options.font ? options.font : defaultOptions.font,
      width: options.width !== undefined ? options.width : defaultOptions.width,
      height:
        options.height !== undefined ? options.height : defaultOptions.height,
      itemHeight:
        options.itemHeight !== undefined
          ? options.itemHeight
          : defaultOptions.itemHeight,
      itemOffset:
        options.itemOffset !== undefined
          ? options.itemOffset
          : defaultOptions.itemOffset,
      itemColor:
        options.itemColor !== undefined
          ? options.itemColor
          : defaultOptions.itemColor,
      itemOpacity:
        options.itemOpacity !== undefined
          ? options.itemOpacity
          : defaultOptions.itemOpacity,
      itemSelectOpacity:
        options.itemSelectOpacity !== undefined
          ? options.itemSelectOpacity
          : defaultOptions.itemSelectOpacity,
      itemBgMap: options.itemBgMap
        ? options.itemBgMap
        : defaultOptions.itemBgMap,
      itemSelectColor:
        options.itemSelectColor !== undefined
          ? options.itemSelectColor
          : defaultOptions.itemSelectColor,
      visibleBtnIcon: options.visibleBtnIcon
        ? options.visibleBtnIcon
        : defaultOptions.visibleBtnIcon,
      radius:
        options.radius !== undefined ? options.radius : defaultOptions.radius,
      sliderColor:
        options.sliderColor !== undefined
          ? options.sliderColor
          : defaultOptions.sliderColor,
      handleColor:
        options.handleColor !== undefined
          ? options.handleColor
          : defaultOptions.handleColor,
      unFolder:
        options.unFolder !== undefined
          ? options.unFolder
          : defaultOptions.unFolder,
      visibleBtnStateChangeColor: options.visibleBtnStateChangeColor
        ? options.visibleBtnStateChangeColor
        : null,
      disabledColor:
        options.disabledColor !== undefined
          ? options.disabledColor
          : defaultOptions.disabledColor,
    };
    if (tempOptions.opacity <= 0) tempOptions.opacity = 0.01;
    if (tempOptions.itemOpacity <= 0) tempOptions.itemOpacity = 0.01;
    if (tempOptions.visibleBtnIcon) {
      if (!Array.isArray(tempOptions.visibleBtnIcon))
        tempOptions.visibleBtnIcon = [tempOptions.visibleBtnIcon];
    }

    super(tempOptions, vuiLib);
    this._vType = "VTree";

    this._otherProps = {
      sliderSpeed: 0.02, // 通过按键滑动视图时的速度
      itemFrontDepthOffset: 0.04, // 每增加一层深度，前面多空出的距离
      data: tempOptions.data,
      padding: tempOptions.padding,
      dataTextName: tempOptions.dataTextName,
      dataUniqueName: tempOptions.dataUniqueName,
      dataChildrenName: tempOptions.dataChildrenName,
      itemHeight: tempOptions.itemHeight,
      itemOffset: tempOptions.itemOffset,
      itemColor: tempOptions.itemColor,
      itemSelectColor: tempOptions.itemSelectColor,
      itemSelectOpacity: tempOptions.itemSelectOpacity,
      itemOpacity: tempOptions.itemOpacity,
      itemBgMap: tempOptions.itemBgMap,
      visibleBtnIcon: tempOptions.visibleBtnIcon,
      sliderColor: tempOptions.sliderColor,
      unFolder: tempOptions.unFolder,
      handleColor: tempOptions.handleColor,
      visibleBtnStateChangeColor: tempOptions.visibleBtnStateChangeColor,
      onElementHoverEnter: [],
      onElementHoverExit: [],
      onElementClick: [],
      onVisibleBtnClick: [],
    };

    this.stencilRef = this.vuilib.getStencil();
    this.uiContents = []; // 存储添加到滚动区域的UI对象
    this.needAddUIs = []; // 准备添加到滚动区域的UI对象
    this.needRemoveUIs = [];
    this.needRemoveUIIndexs = [];
    this.interval = null;
    this.lastSelectItems = [];

    this.renderOrder = this._baseProps.renderOrder - 10;
    this.name = "VTree";

    // 遮罩区域
    {
      this.viewWidth = this._baseProps.width - this._otherProps.padding * 2;
      if (this.viewWidth <= 0) {
        console.warn("树形结构宽度设置错误");
        this.viewWidth = this._baseProps.width;
      }
      this.viewHeight = this._baseProps.height - this._otherProps.padding * 2;
      if (this.viewHeight <= 0) {
        console.warn("树形结构高度设置错误");
        this.viewHeight = this._baseProps.height;
      }
      let geo = VUtil.createRectangleGeometry(
        this.viewWidth,
        this.viewHeight,
        this._baseProps.radius
      );
      let maskMat = new MeshBasicMaterial({
        color: 0xff0000,
        side: DoubleSide,
        stencilWrite: true, // 启用模板写入
        stencilRef: this.stencilRef, // 模板参考值
        stencilFunc: AlwaysStencilFunc, // 总是通过模板测试
        stencilZPass: ReplaceStencilOp, // 通过深度测试时，将模板值替换为参考值
        transparent: true,
        opacity: 0.01, //0.01,
        depthTest: false,
        depthWrite: false,
        colorWrite: false,
        stencilFuncMask: 0xff, // 使用全8位掩码
        stencilFail: ReplaceStencilOp, // 新增
        stencilZFail: ReplaceStencilOp, // 新增
      });
      //VUtil.convertSRGBToLinear(maskMat);

      this.viewArea = new Mesh(geo, maskMat);
      //this.viewArea.position.z = 0.005;
      //this.viewArea.renderOrder = this._baseProps.renderOrder - 500; // 遮罩需要先渲染
      this.add(this.viewArea);
    }

    // 内容区域
    this.content = new Object3D();
    this.viewArea.add(this.content);
    this.content.position.x = -this.viewWidth / 2;
    this.content.position.y = this.viewHeight / 2;
    this.contentWidth = 0; // 当前滚动视图内容总宽度
    this.contentHeight = 0; // 当前滚动视图内容总高度

    // 滑动条
    {
      let sliderHeight = 0.05;

      // 水平滑动条
      {
        this.horizontalSlider = new VSlider2({
          color: this._otherProps.sliderColor,
          handleColor: this._otherProps.handleColor,
          width: this._baseProps.width,
          height: sliderHeight,
          radius: sliderHeight / 2,
        });
        this.horizontalSlider.setProgressValue(0);

        this.add(this.horizontalSlider);
        this.horizontalSlider.position.y =
          -this._baseProps.height / 2 + sliderHeight / 2;
        this.horizontalSlider.position.z += 0.004;

        this.horizontalSlider.visible = false;

        this.horizontalSlider.addOnValueChangeEvent((v) => {
          this._horizontalSliderValueChanged(v);
        });

        this.horizontalSlider.addHoverEnterEvent(() => {
          this.onHoverEnter();
        });
        this.horizontalSlider.addHoverExitEvent(() => {
          this.onHoverExit();
        });
        this.horizontalSlider.addHandlerHoverEnterEvent(() => {
          this.onHoverEnter();
        });
        this.horizontalSlider.addHandlerHoverExitEvent(() => {
          this.onHoverExit();
        });
      }
      // 垂直滑动条
      {
        this.verticleSlider = new VSlider2({
          color: this._otherProps.sliderColor,
          handleColor: this._otherProps.handleColor,
          width: this._baseProps.height,
          height: sliderHeight,
          radius: sliderHeight / 2,
        });
        this.verticleSlider.setProgressValue(0);
        this.verticleSlider.rotateZ(-Math.PI / 2);

        this.add(this.verticleSlider);
        this.verticleSlider.position.x =
          this._baseProps.width / 2 - sliderHeight / 2;
        this.verticleSlider.position.z += 0.005;

        this.verticleSlider.visible = false;

        this.verticleSlider.addOnValueChangeEvent((v) => {
          this._verticleSliderValueChanged(v);
        });
        this.verticleSlider.addOnValueChangeEndEvent((v) => {
          // 修改滑动条后重新计算当前的显示元素
          this.visibleElements = this._getVisibleElement();
        });
        this.verticleSlider.addHoverEnterEvent(() => {
          this.onHoverEnter();
        });
        this.verticleSlider.addHoverExitEvent(() => {
          this.onHoverExit();
        });
        this.verticleSlider.addHandlerHoverEnterEvent(() => {
          this.onHoverEnter();
        });
        this.verticleSlider.addHandlerHoverExitEvent(() => {
          this.onHoverExit();
        });
      }

      if (this.vuilib) {
        this.vuilib.addComponents(this.horizontalSlider, this._priority);
        this.vuilib.addComponents(
          this.horizontalSlider.handle,
          this._priority - 1
        );
        this.vuilib.addComponents(this.verticleSlider, this._priority);
        this.vuilib.addComponents(
          this.verticleSlider.handle,
          this._priority - 1
        );
      }
    }

    this.width = this._baseProps.width;
    this.height = this._baseProps.height;

    this._initData(this._otherProps.data);
  }

  async _initData(data) {
    if (!data) return;

    const flatData = this._setupData(data);
    if (!flatData) return;
    this.elements = [];

    this.openIcon = await new TextureLoader().loadAsync(
      "/assets/vrUILib/tree/open.png"
    );
    this.closeIcon = await new TextureLoader().loadAsync(
      "/assets/vrUILib/tree/close.png"
    );

    // 避免水平方向内容过长，这里把背景定义很长
    this.itemGeo = new PlaneGeometry(
      this.viewWidth * 100,
      this._otherProps.itemHeight
    );
    this.itemMat = new MeshBasicMaterial({
      color: this._otherProps.itemColor,
      transparent: true,
      opacity: this._otherProps.itemOpacity,
      depthTest: this.depthTest,
    });
    VUtil.convertSRGBToLinear(this.itemMat);
    this._setMatStancil(this.itemMat);
    // 选中的项背景材质
    this.selectItemMat = new MeshBasicMaterial({
      color: this._otherProps.itemSelectColor,
      transparent: true,
      opacity: this._otherProps.itemSelectOpacity,
      depthTest: this.depthTest,
    });
    VUtil.convertSRGBToLinear(this.selectItemMat);
    this._setMatStancil(this.selectItemMat);

    for (var i = 0; i < flatData.length; i++) {
      const item = this._addItem(flatData[i]);
      this.content.add(item);
      this.elements.push(item);
    }

    this._updateElementPosition();

    this.visibleElements = this._getVisibleElement();
  }

  /**
   * 对数据进行预处理
   * @param {*} data
   * @returns
   */
  _setupData(data) {
    // 重新组织数据，将dataUniqueName替换成id，将dataChildrenName替换成children
    this.newData = [];
    {
      const traverse = (array, newParentNode) => {
        if (array) {
          for (var i = 0; i < array.length; i++) {
            const temp = {
              srcData: array[i],
              children: [],
              text: array[i][this._otherProps.dataTextName]
                ? array[i][this._otherProps.dataTextName]
                : "i",
              objVisible:
                array[i].visible !== undefined ? array[i].visible : true,
              visible: true,
              parent: newParentNode,
            };
            if (this._otherProps.dataUniqueName) {
              temp.id = array[i][this._otherProps.dataUniqueName];
            }
            // 不存在唯一标识，生成一个默认的唯一id
            else {
              const idObj = new Object3D();
              temp.id = idObj.id;
            }

            newParentNode.children.push(temp);
            newParentNode.isFolder = true;
            newParentNode.unFolder = this._otherProps.unFolder; // 是否展开子节点

            if (
              this._otherProps.dataChildrenName &&
              array[i][this._otherProps.dataChildrenName]
            ) {
              traverse(array[i][this._otherProps.dataChildrenName], temp);
            }
          }
        }
      };
      for (var i = 0; i < data.length; i++) {
        const temp = {
          srcData: data[i],
          children: [],
          text: data[i][this._otherProps.dataTextName]
            ? data[i][this._otherProps.dataTextName]
            : "text",
          visible: true,
          objVisible: data[i].visible !== undefined ? data[i].visible : true,
          parent: null,
        };
        if (this._otherProps.dataUniqueName) {
          temp.id = data[i][this._otherProps.dataUniqueName];
        }
        // 不存在唯一标识，生成一个默认的唯一id
        else {
          const idObj = new Object3D();
          temp.id = idObj.id;
        }
        this.newData.push(temp);
        if (
          this._otherProps.dataChildrenName &&
          data[i][this._otherProps.dataChildrenName]
        ) {
          traverse(data[i][this._otherProps.dataChildrenName], temp);
        }
      }
    }

    // 扁平化存储
    {
      if (this.newData.length <= 0) return;
      const flatData = [];
      const traverse = (array, depth) => {
        for (var i = 0; i < array.length; i++) {
          array[i].depth = depth;
          flatData.push(array[i]);

          if (array[i].children && array[i].children.length > 0) {
            traverse(array[i].children, depth + 1);
          }
        }
      };
      let depth = 0;
      for (var i = 0; i < this.newData.length; i++) {
        this.newData[i].depth = depth;
        this.newData[i].visible = true;
        flatData.push(this.newData[i]);

        if (this.newData[i].children && this.newData[i].children.length > 0) {
          traverse(this.newData[i].children, depth + 1);
        }
      }

      // 设置初始是否展开子节点
      const hideChildren = (node) => {
        if (node.children && node.children.length > 0) {
          for (var i = 0; i < node.children.length; i++) {
            node.children[i].visible = false;
            hideChildren(node.children[i]);
          }
        }
      };
      if (!this._otherProps.unFolder) {
        for (var i = 0; i < this.newData.length; i++) {
          hideChildren(this.newData[i]);
        }
      }

      return flatData;
    }
  }

  /**
   * 设置材质的模板值，如果添加的元素内部有VText类型，则需要在添加到滚动视图后再设置
   * 包括后面对元素进行修改后也需要重新设置
   * @param {*} mat
   */
  _setMatStancil(mat) {
    if (!mat) return;
    if (!Array.isArray(mat)) mat = [mat];
    for (var i = 0; i < mat.length; i++) {
      mat[i].stencilWrite = true;
      mat[i].stencilRef = this.stencilRef;
      mat[i].stencilFunc = EqualStencilFunc;
      mat[i].stencilZFail = KeepStencilOp;
      mat[i].transparent = true;
      mat[i].stencilFuncMask = 0xff; // 使用全8位掩码
      //mat[i].stencilFail = KeepStencilOp; // 新增 高版本（171）不能加这个
    }
  }

  _addItem(itemData) {
    let item = new Object3D();

    item.position.x = -this.viewWidth / 2;
    item.position.z = 0.001;
    let bg = new Mesh(this.itemGeo, this.itemMat);
    item.add(bg);
    item.name = itemData.text;

    bg.position.x = this.viewWidth * 50;
    bg.renderOrder = this._baseProps.renderOrder + 10;
    bg.name = itemData.text;
    bg._treeData = itemData;
    itemData._node = item;

    item.visible = itemData.visible;

    if (this._otherProps.itemBgMap) {
      let geo = new PlaneGeometry(
        this._baseProps.width,
        this._otherProps.itemHeight
      );
      let mat = new MeshBasicMaterial({
        map: this._otherProps.itemBgMap,
        transparent: true,
        opacity: 1,
        depthTest: this.depthTest,
      });
      this._setMatStancil(mat);
      const mapBg = new Mesh(geo, mat);
      mapBg.renderOrder = this._baseProps.renderOrder + 10;
      mapBg.position.x = this.viewWidth;

      item.add(mapBg);
    }

    // 设置事件
    bg.onEcsyHoverEnter = (target) => {
      this._onElementHoverEnter(target);
    };
    bg.onEcsyHoverExit = (target) => {
      this._onElementHoverExit(target);
    };
    // 注册是否可选中当前ui
    bg.onEcsycheckSelectable = (worldPos) => {
      return this.checkSelectable(worldPos);
    };
    bg.onVRClick = (obj, clickObj) => {
      // 不允许树节点响应点击事件
      if (!this.enableElementClick) return;

      // 超出范围不响应
      const localPos = this.worldToLocal(clickObj.point.clone());
      if (
        localPos.y > this.viewHeight / 2 ||
        localPos.y < -this.viewHeight / 2 ||
        localPos.x > this.viewWidth / 2 ||
        localPos.x < -this.viewWidth / 2
      )
        return;
      // 正在获取当前显示元素，暂不响应
      if (this.updateVisibleElementEvent) return;

      if (this.lastSelectItems) {
        for (var i = 0; i < this.lastSelectItems.length; i++) {
          this.lastSelectItems[i].material = this.itemMat;
        }
        this.lastSelectItems = [];
      }
      this.lastSelectItems.push(obj);
      obj.material = this.selectItemMat;

      for (var i = 0; i < this._otherProps.onElementClick.length; i++) {
        this._otherProps.onElementClick[i](obj._treeData.srcData);
      }
    };

    if (this.vuilib) {
      this.vuilib.addComponents(bg, this._priority - 1);
    }

    //text
    const text = VUtil.createText(
      itemData.text,
      this._textProps.textSize,
      this._textProps.textColor,
      this._textProps.font,
      (tex) => {
        tex.position.x =
          this._otherProps.itemFrontDepthOffset * (tex._depth + 1) -
          this.viewWidth / 2 +
          this.viewWidth;

        item.width =
          tex.position.x + tex._width + this.viewWidth / 2 - this.viewWidth;

        if (item.width > this.contentWidth) this.contentWidth = item.width;
      }
    );
    text._depth = itemData.depth;
    this._setMatStancil(text.material);
    text.renderOrder = this._baseProps.renderOrder + 10;
    item.add(text);
    text.position.z = 0.001;
    bg._text = text;

    // 不管当前是否是文件夹都需要 创建展开关闭按钮 ，因为后面可以添加新内容
    {
      let length = (this._otherProps.itemHeight / 5) * 4;
      let openBtn = new VButton({
        width: this._otherProps.itemHeight * 0.8,
        height: this._otherProps.itemHeight * 0.8,
        text: "",
        map: this.openIcon,
      });
      openBtn.addClickEvent((btn) => {
        this.unFolderItem(btn._item.children[0]._treeData, true);

        btn._item.children[0]._treeData.unFolder = true;
        // 如果当前光标还在这个item上
        if (
          this.curHoverElement &&
          (this.curHoverElement === btn ||
            this.curHoverElement === btn._item.children[0])
        ) {
          btn.visible = false;
          btn._item._closeBtn.visible = true;
          btn._item._closeBtn.position.copy(btn.position);
        }
      });

      this._setMatStancil(openBtn.material);
      this._setMatStancil(openBtn.children[0].material);
      // 设置事件
      openBtn.addHoverEnterEvent((target) => {
        this._onElementHoverEnter(target);
      });
      openBtn.addHoverExitEvent((target) => {
        this._onElementHoverExit(target);
      });
      // 注册是否可选中当前ui
      openBtn.addCheckSelectableEvent((worldPos) => {
        return this.checkSelectable(worldPos);
      });

      item.add(openBtn);
      openBtn.position.z = 0.005;
      openBtn._treeData = itemData;

      let closeBtn = new VButton({
        width: this._otherProps.itemHeight * 0.8,
        height: this._otherProps.itemHeight * 0.8,
        text: "",
        map: this.closeIcon,
      });

      closeBtn.addClickEvent((btn) => {
        this.unFolderItem(btn._item.children[0]._treeData, false);

        btn._item.children[0]._treeData.unFolder = false;
        // 如果当前光标还在这个item上
        if (
          this.curHoverElement &&
          (this.curHoverElement === btn ||
            this.curHoverElement === btn._item.children[0])
        ) {
          btn.visible = false;
          btn._item._openBtn.visible = true;
          btn._item._openBtn.position.copy(btn.position);
        }
      });
      // 设置事件
      closeBtn.addHoverEnterEvent((target) => {
        this._onElementHoverEnter(target);
      });
      closeBtn.addHoverExitEvent((target) => {
        this._onElementHoverExit(target);
      });
      // 注册是否可选中当前ui
      closeBtn.addCheckSelectableEvent((worldPos) => {
        return this.checkSelectable(worldPos);
      });

      this._setMatStancil(closeBtn.material);
      this._setMatStancil(closeBtn.children[0].material);

      item.add(closeBtn);
      closeBtn.position.z = 0.005;
      closeBtn._treeData = itemData;
      openBtn._item = item;
      closeBtn._item = item;
      item._openBtn = openBtn;
      item._closeBtn = closeBtn;

      openBtn.visible = false;
      closeBtn.visible = false;
    }
    // 创建显示隐藏按钮
    if (
      this._otherProps.visibleBtnIcon &&
      this._otherProps.visibleBtnIcon.length > 0
    ) {
      let visibleBtn = new VButton(
        {
          priority: this._priority - 2,
          width: this._otherProps.itemHeight,
          height: this._otherProps.itemHeight,
          map:
            this._otherProps.visibleBtnIcon.length > 1 && !itemData.objVisible
              ? this._otherProps.visibleBtnIcon[1]
              : this._otherProps.visibleBtnIcon[0],
          text: "",
          stateChangeColor: this._otherProps.visibleBtnStateChangeColor,
        },
        this.vuilib
      );
      visibleBtn.addClickEvent((btn) => {
        const srcValue = btn._item.children[0]._treeData.objVisible;
        if (this._otherProps.visibleBtnIcon.length > 1) {
          if (srcValue) {
            btn.material.map = this._otherProps.visibleBtnIcon[1];
          } else {
            btn.material.map = this._otherProps.visibleBtnIcon[0];
          }
          btn.material.needsUpdate = true;
        }
        btn._item.children[0]._treeData.objVisible = !srcValue;

        for (var i = 0; i < this._otherProps.onVisibleBtnClick.length; i++) {
          this._otherProps.onVisibleBtnClick[i](
            btn._item.children[0]._treeData,
            !srcValue
          );
        }
      });
      // 设置事件
      visibleBtn.addHoverEnterEvent((target) => {
        this._onElementHoverEnter(target);
      });
      visibleBtn.addHoverExitEvent((target) => {
        this._onElementHoverExit(target);
      });
      // 注册是否可选中当前ui
      visibleBtn.addCheckSelectableEvent((worldPos) => {
        return this.checkSelectable(worldPos);
      });

      this._setMatStancil(visibleBtn.material);
      this._setMatStancil(visibleBtn.children[0].material);

      item.add(visibleBtn);
      visibleBtn.position.z = 0.001;
      visibleBtn.position.x =
        this.viewWidth * 1.5 - this._otherProps.itemHeight * 2.2;
      visibleBtn._item = item;
      item._visibleBtn = visibleBtn;
      visibleBtn._treeData = itemData;

      if (!this.visibleBtns) this.visibleBtns = [];
      this.visibleBtns.push(visibleBtn);
    }

    return item;
  }

  /**
   * 展开或关闭某个元素
   * @param {*} item
   * @param {*} isOpen
   */
  unFolderItem(item, isOpen) {
    if (!this._baseProps.enabled) return;
    if (item.isFolder && item.unFolder !== isOpen) {
      item.unFolder = isOpen;

      function traverse(node, isOpen) {
        if (node.children && node.children.length > 0) {
          for (var i = 0; i < node.children.length; i++) {
            if (!isOpen) {
              node.children[i]._node.visible = false;
              traverse(node.children[i], false);
            } else {
              if (node.unFolder) {
                node.children[i].visible = true;
              }
              node.children[i]._node.visible = node.children[i].visible;
              traverse(node.children[i], node.children[i].visible);
            }
          }
        }
      }

      for (var i = 0; i < item.children.length; i++) {
        item.children[i].visible = isOpen;
        item.children[i]._node.visible = isOpen;

        traverse(item.children[i], isOpen);
      }

      this._updateElementPosition();

      this.visibleElements = this._getVisibleElement();

      // 垂直滚动条
      {
        // 从不需要滚动变成需要滚动
        if (
          this.contentHeight > this.viewHeight &&
          !this.verticleSlider.visible
        ) {
          this.verticleSlider.visible = true;
          this.verticleSlider.setProgressValue(0);
        }
        // 从需要滚动变成不需要滚动
        else if (
          this.contentHeight < this.viewHeight &&
          this.verticleSlider.visible
        ) {
          this.verticleSlider.setProgressValue(0);
          this.content.position.y = this.viewHeight / 2;
          this.verticleSlider.visible = false;
        } else if (this.contentHeight > this.viewHeight) {
          let offset = this.contentHeight - this.viewHeight;
          // 太高了，底部有空白
          if (this.content.position.y > this.viewHeight / 2 + offset) {
            this.verticleSlider.setProgressValue(1);
            this.content.position.y = this.viewHeight / 2 + offset;
          }
        }
      }
      // 水平滚动条
      {
        // 从不需要滚动变成需要滚动
        if (
          this.contentWidth > this.viewWidth &&
          !this.horizontalSlider.visible
        ) {
          this.horizontalSlider.visible = true;
          this.horizontalSlider.setProgressValue(0);
        } // 从需要滚动变成不需要滚动
        else if (
          this.contentWidth < this.viewWidth &&
          this.horizontalSlider.visible
        ) {
          this.horizontalSlider.setProgressValue(0);
          this.content.position.x = -this.viewWidth / 2;
          this.horizontalSlider.visible = false;
        } else if (this.contentWidth > this.viewWidth) {
          let offset = this.contentWidth - this.viewWidth;
          // 太宽了，右边有空白
          if (this.content.position.x < -this.viewWidth / 2 - offset) {
            this.horizontalSlider.setProgressValue(1);
            this.content.position.x = -this.viewWidth / 2 - offset;
          }
        }
      }
    }
  }

  /**
   * 更新所有元素的可见性
   */
  _updateElementeVisible() {
    for (var i = 0; i < this.elements.length; i++) {
      const treeData = this.elements[i].children[0]._treeData;
      this.elements[i].visible = treeData.visible;
    }
  }

  /**
   * 更新所有可见元素的位置
   */
  _updateElementPosition() {
    let visibleCount = 0;
    this.contentWidth = 0;
    for (var i = 0; i < this.elements.length; i++) {
      if (this.elements[i].visible) {
        this.elements[i].position.y =
          -visibleCount *
            (this._otherProps.itemHeight + this._otherProps.itemOffset) -
          this._otherProps.itemHeight / 2;

        // 文字对象创建需要时间，此时还未创建完成
        if (this.elements[i].width) {
          if (this.elements[i].width > this.contentWidth)
            this.contentWidth = this.elements[i].width;
        }

        visibleCount++;
      }
    }

    this.contentHeight =
      visibleCount *
        (this._otherProps.itemHeight + this._otherProps.itemOffset) -
      this._otherProps.itemOffset;
  }

  clear() {
    this.horizontalSlider.clear();
    this.verticleSlider.clear();
    this._clearBorder();

    super.clear();
  }

  /**
   * 水平滑动条变化时的回调
   * @param {*} v
   */
  _horizontalSliderValueChanged(v) {
    if (this.contentWidth > this.viewWidth)
      this.content.position.x =
        -this.viewWidth / 2 - v * (this.contentWidth - this.viewWidth);
  }

  /**
   * 垂直滑动条变化时的回调
   * @param {*} v
   */
  _verticleSliderValueChanged(v) {
    if (this.contentHeight > this.viewHeight)
      this.content.position.y =
        this.viewHeight / 2 + v * (this.contentHeight - this.viewHeight);
  }

  _onLeftBtnEvent(value) {
    if (!this._baseProps.enabled) return;
    if (this.horizontalSlider.value <= 0) return;

    const speed = Math.abs(value) * this._otherProps.sliderSpeed;

    if (this.horizontalSlider.value - speed >= 0) {
      this.horizontalSlider.setProgressValue(
        this.horizontalSlider.value - speed
      );
    } else {
      this.horizontalSlider.setProgressValue(0);
    }

    const contentOffset = this.content.position.x + this.viewWidth / 2;
    if (this.border && this.border.visible) {
      this.border.position.x = this.viewWidth / 2 - contentOffset;
    }

    if (this.curHoverElement) {
      let item = this.curHoverElement.parent;
      // 关闭、打开按钮
      if (
        this.curHoverElement._vType &&
        this.curHoverElement._vType == "VButton"
      )
        item = this.curHoverElement._item;
      if (item._closeBtn && item._closeBtn.visible) {
        item._closeBtn.position.x =
          this.viewWidth * 1.5 - this._otherProps.itemHeight - contentOffset;
      } else if (item._openBtn && item._openBtn.visible) {
        item._openBtn.position.x =
          this.viewWidth * 1.5 - this._otherProps.itemHeight - contentOffset;
      }
    }

    // 更新显示按钮
    if (this.visibleBtns) {
      for (var i = 0; i < this.visibleBtns.length; i++) {
        this.visibleBtns[i].position.x =
          this.viewWidth * 1.5 -
          this._otherProps.itemHeight * 2.2 -
          contentOffset;
      }
    }
  }

  _onRightBtnEvent(value) {
    if (!this._baseProps.enabled) return;
    if (this.horizontalSlider.value >= 1) return;

    const speed = Math.abs(value) * this._otherProps.sliderSpeed;

    if (this.horizontalSlider.value + speed <= 1) {
      this.horizontalSlider.setProgressValue(
        this.horizontalSlider.value + speed
      );
    } else {
      this.horizontalSlider.setProgressValue(1);
    }

    const contentOffset = this.content.position.x + this.viewWidth / 2;
    if (this.border && this.border.visible) {
      this.border.position.x = this.viewWidth / 2 - contentOffset;
    }

    if (this.curHoverElement) {
      let item = this.curHoverElement.parent;
      // 关闭、打开按钮
      if (
        this.curHoverElement._vType &&
        this.curHoverElement._vType == "VButton"
      )
        item = this.curHoverElement._item;
      if (item._closeBtn && item._closeBtn.visible) {
        item._closeBtn.position.x =
          this.viewWidth * 1.5 - this._otherProps.itemHeight - contentOffset;
      } else if (item._openBtn && item._openBtn.visible) {
        item._openBtn.position.x =
          this.viewWidth * 1.5 - this._otherProps.itemHeight - contentOffset;
      }
    }

    // 更新显示按钮
    if (this.visibleBtns) {
      for (var i = 0; i < this.visibleBtns.length; i++) {
        this.visibleBtns[i].position.x =
          this.viewWidth * 1.5 -
          this._otherProps.itemHeight * 2.2 -
          contentOffset;
      }
    }
  }

  _onUpBtnEvent(value) {
    if (!this._baseProps.enabled) return;
    if (this.verticleSlider.value >= 1) return;

    const speed = Math.abs(value) * this._otherProps.sliderSpeed;
    if (this.verticleSlider.value + speed <= 1) {
      this.verticleSlider.setProgressValue(this.verticleSlider.value + speed);
    } else {
      this.verticleSlider.setProgressValue(1);
    }

    // 使用上、下按键修改滑动条数值后0.3s再计算当前显示元素，避免重复计算
    if (this.updateVisibleElementEvent) {
      clearTimeout(this.updateVisibleElementEvent);
      this.updateVisibleElementEvent = null;
    }
    this.updateVisibleElementEvent = setTimeout(() => {
      this.visibleElements = this._getVisibleElement();
      this.updateVisibleElementEvent = null;
    }, 300);
  }

  _onDownBtnEvent(value) {
    if (!this._baseProps.enabled) return;
    if (this.verticleSlider.value <= 0) return;

    const speed = Math.abs(value) * this._otherProps.sliderSpeed;

    if (this.verticleSlider.value - speed >= 0) {
      this.verticleSlider.setProgressValue(this.verticleSlider.value - speed);
    } else {
      this.verticleSlider.setProgressValue(0);
    }

    // 使用上、下按键修改滑动条数值后0.3s再计算当前显示元素，避免重复计算
    if (this.updateVisibleElementEvent) {
      clearTimeout(this.updateVisibleElementEvent);
      this.updateVisibleElementEvent = null;
    }
    this.updateVisibleElementEvent = setTimeout(() => {
      this.visibleElements = this._getVisibleElement();
      this.updateVisibleElementEvent = null;
    }, 300);
  }

  /**
   * 光标进入滚动视图
   */
  onHoverEnter() {
    if (!this._baseProps.enabled) return;
    this.vuilib.onUpBtnEvent = (value) => {
      this._onUpBtnEvent(value);
    };
    this.vuilib.onDownBtnEvent = (value) => {
      this._onDownBtnEvent(value);
    };
    this.vuilib.onLeftBtnEvent = (value) => {
      this._onLeftBtnEvent(value);
    };
    this.vuilib.onRightBtnEvent = (value) => {
      this._onRightBtnEvent(value);
    };

    this.pointerHover = true; // 光标当前在树结构内

    // 设置滑动条显示隐藏
    if (this.contentWidth > this.viewWidth) {
      this.horizontalSlider.visible = true;
    }
    if (this.contentHeight > this.viewHeight) {
      this.verticleSlider.visible = true;
    }

    super.onHoverEnter();
  }

  /**
   * 光标离开滚动视图
   */
  onHoverExit() {
    // if (!this._baseProps || !this._baseProps.enabled) return;
    this.vuilib.onUpBtnEvent = null;
    this.vuilib.onDownBtnEvent = null;
    this.vuilib.onLeftBtnEvent = null;
    this.vuilib.onRightBtnEvent = null;

    this.pointerHover = false; // 光标当前在树结构内

    // 设置滑动条显示隐藏
    this.horizontalSlider.visible = false;
    this.verticleSlider.visible = false;

    super.onHoverExit();
  }

  _onElementHoverEnter(target) {
    if (!this._baseProps.enabled) return;
    this.curHoverElement = target;

    if (this._otherProps.onElementHoverEnter.length > 0) {
      for (var i = 0; i < this._otherProps.onElementHoverEnter.length; i++) {
        this._otherProps.onElementHoverEnter[i](target);
      }
    } else {
      if (!this.border) {
        this.border = this._createBorder(
          this.viewWidth,
          this._otherProps.itemHeight
        );
        this.content.add(this.border);
        this.border.position.z += 0.001;
        this.border.position.x += this.viewWidth / 2;
      }
      this.border.visible = true;
    }

    let item = target.parent;
    // 关闭、打开按钮
    if (target._vType && target._vType == "VButton") item = target._item;

    const contentOffset = this.content.position.x + this.viewWidth / 2;

    if (this.border) {
      this.border.position.y = item.position.y;
      this.border.position.x = this.viewWidth / 2 - contentOffset;
    }

    if (target._treeData.isFolder) {
      if (target._treeData.unFolder) {
        item._closeBtn.visible = true;
        item._closeBtn.position.x =
          this.viewWidth * 1.5 - this._otherProps.itemHeight - contentOffset;
      } else {
        item._openBtn.visible = true;
        item._openBtn.position.x =
          this.viewWidth * 1.5 - this._otherProps.itemHeight - contentOffset;
      }
    }

    this.onHoverEnter();
  }

  _onElementHoverExit(target) {
    if (!this._baseProps.enabled) return;
    //console.log(target);

    this.curHoverElement = null;
    if (this._otherProps.onElementHoverExit.length > 0) {
      for (var i = 0; i < this._otherProps.onElementHoverExit.length; i++) {
        this._otherProps.onElementHoverExit[i](target);
      }
    } else {
      if (this.border) this.border.visible = false;
    }

    let item = target.parent;
    // 关闭、打开按钮
    if (target._vType && target._vType == "VButton") item = target._item;
    if (target._treeData.isFolder) {
      if (target._treeData.unFolder) {
        item._closeBtn.visible = false;
      } else {
        item._openBtn.visible = false;
      }
    }

    this.onHoverExit();
  }

  /**
   * 获取当前可见的元素
   */
  _getVisibleElement() {
    let offset =
      this.contentHeight -
      (this.viewHeight +
        (this._otherProps.itemHeight + this._otherProps.itemOffset) * 2);

    if (offset < 0) {
      return this.elements;
    }

    let topCount = Math.floor(
      (this.verticleSlider.value * (this.contentHeight - this.viewHeight)) /
        (this._otherProps.itemHeight + this._otherProps.itemOffset)
    );

    let resCount = Math.floor(
      (this.viewHeight +
        (this._otherProps.itemHeight + this._otherProps.itemOffset) * 2) /
        (this._otherProps.itemHeight + this._otherProps.itemOffset)
    );

    var count = 0;
    let res = [];
    for (var i = 0; i < this.elements.length; i++) {
      if (this.elements[i].visible) {
        count++;
        if (count > topCount) {
          res.push(this.elements[i]);
          if (count >= topCount + resCount) break;
        }
      }
    }

    return res;
  }

  getClickable() {
    if (!this.visible || !this._baseProps.enabled) return [];
    let res = [];
    if (this.horizontalSlider.visible) {
      res.push(this.horizontalSlider.handle);
    }
    if (this.verticleSlider.visible) {
      res.push(this.verticleSlider.handle);
    }

    if (this.visibleElements) {
      for (var i = 0; i < this.visibleElements.length; i++) {
        res.push(this.visibleElements[i].children[0]);
        if (
          this.visibleElements[i]._openBtn &&
          this.visibleElements[i]._openBtn.visible
        )
          res.push(this.visibleElements[i]._openBtn);
        if (
          this.visibleElements[i]._closeBtn &&
          this.visibleElements[i]._closeBtn.visible
        )
          res.push(this.visibleElements[i]._closeBtn);
      }
    }
    if (this.visibleBtns) res = res.concat(this.visibleBtns);
    return res;
  }

  /**
   * 重写基类的检测是否可选中事件
   * @param {*} worldPos
   * @returns
   */
  checkSelectable(worldPos) {
    if (!this._baseProps.enabled) return false;

    const localPos = this.worldToLocal(worldPos);

    if (isNaN(localPos.x) || isNaN(localPos.y)) return false;

    if (
      Math.abs(localPos.y) > this.viewHeight / 2 ||
      Math.abs(localPos.x) > this.viewWidth / 2
    ) {
      return false;
    }
    return true;
  }

  _createBorder(width, height) {
    this._clearBorder();
    let points = [
      -width / 2,
      height / 2,
      0,

      width / 2,
      height / 2,
      0,

      width / 2,
      -height / 2,
      0,

      -width / 2,
      -height / 2,
      0,

      -width / 2,
      height / 2,
      0,
    ];

    let color = new Color(0xff6d33);
    let colors = [
      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,

      color.r,
      color.g,
      color.b,
    ];

    const geometry = new LineGeometry();
    geometry.setPositions(points);
    geometry.setColors(colors);
    const matLine = new LineMaterial({
      color: 0xffffff,
      linewidth: 0.002, // in world units with size attenuation, pixels otherwise
      vertexColors: true,
      dashed: false,
      alphaToCoverage: true,
      transparent: true,

      stencilWrite: true, // 启用模板写入
      stencilRef: this.stencilRef, // 模板参考值
      stencilFunc: EqualStencilFunc, // 只渲染模板值等于参考值的区域
      stencilZFail: KeepStencilOp, // 深度测试失败时保持模板值
      stencilFuncMask: 0xff, // 使用全8位掩码
      stencilFail: KeepStencilOp, // 新增
    });

    const line = new Line2(geometry, matLine);
    //line.computeLineDistances();
    line.renderOrder = this._baseProps.renderOrder + 1;
    return line;
  }

  _clearBorder() {
    if (this.border) {
      this.border.geometry.dispose();
      this.border.material.dispose();
      this.border.removeFromParent();
      this.border = null;
    }
  }

  /**
   * 给树形结构添加一项内容
   * @param {Array} data 数组，可以嵌套包含任意多的子节点
   * @param {*} id 父节点的id/index，若此参数为null或不存在该id，将会添加在最外层
   */
  addContent(data, id) {
    function findLast(treeData) {
      if (treeData) {
        if (!treeData.children || treeData.children <= 0) {
          return treeData;
        } else {
          return findLast(treeData.children[treeData.children.length - 1]);
        }
      }
    }

    const flatData = this._setupData(data);
    if (!flatData) return;
    let parentData = null;
    let targetIndex = -1;
    let lastChildData = null; // 目标父对象下的最后一个孩子（或孙子）
    if (id) {
      for (i = 0; i < this.elements.length; i++) {
        const treeData = this.elements[i].children[0]._treeData;
        // 找到目标父对象，检测此父对象下孩子节点（包括孙子节点）的最后一个
        if (treeData.id === id) {
          //console.log("找到父对象", treeData);
          parentData = treeData;

          // 原先没有子节点
          if (!treeData.isFolder) {
            treeData.isFolder = true;
            treeData.unFolder = false;
            lastChildData = treeData;
            targetIndex = i;
            treeData.children = treeData.children.concat(this.newData); // 将新节点放入父节点数据下
          } else {
            lastChildData = findLast(treeData);
          }

          break;
        }
      }
      if (!lastChildData) {
        console.warn(
          "VTree error: 不存在指定id(" + id + ")的节点，将添加在最外层"
        );
      }
      // 找到最后一个孩子节点的索引
      else if (targetIndex === -1) {
        for (i = 0; i < this.elements.length; i++) {
          const treeData = this.elements[i].children[0]._treeData;
          // 找到目标父对象，检测此父对象下孩子节点（包括孙子节点）的最后一个
          if (treeData.id === lastChildData.id) {
            targetIndex = i;
            break;
          }
        }
        parentData.children = parentData.children.concat(this.newData); // 将新节点放入父节点数据下
      }
    }

    // 根据父节点设置当前是否可见
    if (parentData && !parentData.unFolder) {
      for (var i = 0; i < this.newData.length; i++) {
        this.newData[i].visible = false;
      }
    }

    // 设置父对象
    for (var i = 0; i < this.newData.length; i++) {
      this.newData[i].parent = parentData;
    }

    for (var i = 0; i < flatData.length; i++) {
      // 重新设置深度
      if (parentData) flatData[i].depth += parentData.depth + 1;

      const item = this._addItem(flatData[i]);
      this.content.add(item);
      if (targetIndex === -1) this.elements.push(item);
      else this.elements.splice(targetIndex + 1 + i, 0, item);
    }

    this._updateElementPosition();

    this.visibleElements = this._getVisibleElement();
  }

  /**
   * 根据id移除内容
   * @param {Array} ids
   */
  removeContent(ids) {
    if (!ids) return;
    let targetData;
    for (var j = 0; j < ids.length; j++) {
      const id = ids[j];
      for (var i = 0; i < this.elements.length; i++) {
        const treeData = this.elements[i].children[0]._treeData;
        if (treeData.id === id) {
          targetData = treeData;
          break;
        }
      }
      if (!targetData) {
        console.warn(
          "VTree Error: 未找到对应id(" + id + ")的节点，移除内容失败"
        );
        return;
      }
      // 从父节点中移除数据
      if (targetData.parent) {
        for (var i = 0; i < targetData.parent.children.length; i++) {
          if (targetData.parent.children[i].id === targetData.id) {
            targetData.parent.children.splice(i, 1);
            break;
          }
        }
      }
      let self = this;
      // 从场景中删除目标节点及其子节点
      function traverseDelete(node) {
        if (node && node._node) {
          let index = self.elements.indexOf(node._node);
          if (index >= 0) self.elements.splice(index, 1);
          else {
            console.error(
              "VTree error: 移除节点时未从节点列表中找到该移除的节点" + node.id
            );
          }
          self._traverseDispose(node._node);

          if (node.children) {
            for (var i = 0; i < node.children.length; i++) {
              traverseDelete(node.children[i]);
            }
          }
        }
      }

      traverseDelete(targetData);
    }

    this._updateElementPosition();

    this.visibleElements = this._getVisibleElement();
  }

  /**
   * 根据id关闭某个文件夹
   * @param {*} id 节点的id/index
   * @param {Bool} recursive 是否关闭其后代所有节点，默认为false
   */
  folderNode(id, recursive = false) {
    if (!id || !this._baseProps.enabled) return;
    let targetData;
    for (var i = 0; i < this.elements.length; i++) {
      const treeData = this.elements[i].children[0]._treeData;
      if (treeData.id === id) {
        targetData = treeData;
        break;
      }
    }
    if (!targetData) {
      console.warn("VTree Error: 未找到对应id(" + id + ")的节点");
      return;
    }

    if (targetData && !targetData.isFolder) {
      console.warn("VTree Error: 目标节点不是文件夹");
      return;
    }
    targetData.unFolder = false;

    function traverse(node) {
      if (node.children && node.children.length > 0) {
        for (var i = 0; i < node.children.length; i++) {
          node.children[i].visible = false;
          if (recursive && node.children[i].isFolder) {
            node.children[i].unFolder = false;
          }
          traverse(node.children[i]);
        }
      }
    }
    if (recursive) traverse(targetData);
    else {
      for (var i = 0; i < targetData.children.length; i++) {
        targetData.children[i].visible = false;
        if (targetData.children[i].isFolder) {
          targetData.children[i].unFolder = false;
        }
        traverse(targetData.children[i]);
      }
    }

    this._updateElementeVisible();

    this._updateElementPosition();

    this.visibleElements = this._getVisibleElement();
  }

  /**
   * 展开对应id的节点
   * @param {*} id 节点的id/index
   * @param {Bool} recursive 是否展开其后代所有节点，默认为false
   */
  unfolderNode(id, recursive = false) {
    if (!id || !this._baseProps.enabled) return;
    let targetData;
    for (var i = 0; i < this.elements.length; i++) {
      const treeData = this.elements[i].children[0]._treeData;
      if (treeData.id === id) {
        targetData = treeData;
        break;
      }
    }
    if (!targetData) {
      console.warn("VTree Error: 未找到对应id(" + id + ")的节点");
      return;
    }

    if (targetData && !targetData.isFolder) {
      console.warn("VTree Error: 目标节点不是文件夹");
      return;
    }

    targetData.unFolder = true;

    if (recursive) {
      function traverse(node) {
        if (node.children && node.children.length > 0) {
          for (var i = 0; i < node.children.length; i++) {
            node.children[i].visible = targetData.visible;
            if (node.children[i].isFolder) {
              node.children[i].unFolder = true;
              traverse(node.children[i]);
            }
          }
        }
      }
      traverse(targetData);
    } else {
      for (var i = 0; i < targetData.children.length; i++) {
        targetData.children[i].visible = targetData.visible;
      }
    }

    this._updateElementeVisible();

    this._updateElementPosition();

    this.visibleElements = this._getVisibleElement();
  }

  /**
   * 将树形结构聚焦到指定id的节点上
   * @param {Array} ids
   * @param {boolean} isTriggerClickEvent 是否需要触发指定节点的点击事件（如果有），默认为false
   */
  jumpToNode(ids, isTriggerClickEvent) {
    if (!ids || !this._baseProps.enabled) return;
    if (!Array.isArray(ids)) ids = [ids];
    if (this.lastSelectItems) {
      for (var i = 0; i < this.lastSelectItems.length; i++) {
        this.lastSelectItems[i].material = this.itemMat;
      }
      this.lastSelectItems = [];
    }
    for (var j = 0; j < ids.length; j++) {
      const id = ids[j];

      let targetData;
      for (var i = 0; i < this.elements.length; i++) {
        const treeData = this.elements[i].children[0]._treeData;
        if (treeData.id === id) {
          targetData = treeData;
          break;
        }
      }
      if (!targetData) {
        console.warn("VTree Error: 未找到对应id(" + id + ")的节点");
        return;
      }

      // 将目标节点的所有父对象都打开
      let parent = targetData.parent;
      while (parent) {
        if (!parent.unFolder) {
          parent.unFolder = true;
          for (var i = 0; i < parent.children.length; i++) {
            parent.children[i].visible = true;
          }
        }
        parent = parent.parent;
      }

      this._updateElementeVisible();

      // 更新元素位置，获取当前contentHeight
      this._updateElementPosition();

      if (this.pointerHover) {
        if (this.contentHeight > this.viewHeight) {
          this.verticleSlider.visible = true;
        }
        if (this.contentWidth > this.viewWidth) {
          this.horizontalSlider.visible = true;
        }
      }

      // 选中目标节点
      this.lastSelectItems.push(targetData._node.children[0]);
      targetData._node.children[0].material = this.selectItemMat;
      // 触发点击事件
      if (isTriggerClickEvent) {
        for (var i = 0; i < this._otherProps.onElementClick.length; i++) {
          this._otherProps.onElementClick[i](targetData);
        }
      }

      // 只将视线聚焦到第一个选中节点
      if (i === 0) {
        // 需要调整可视范围
        // 计算目标节点的高度
        let visibleCount = 0;
        for (var i = 0; i < this.elements.length; i++) {
          if (this.elements[i].visible) {
            visibleCount++;
            const treeData = this.elements[i].children[0]._treeData;
            if (treeData.id === targetData.id) break;
          }
        }
        const height =
          visibleCount *
            (this._otherProps.itemHeight + this._otherProps.itemOffset) -
          this._otherProps.itemOffset;
        let value =
          (height - this._otherProps.itemHeight) /
          (this.contentHeight - this.viewHeight);
        value = Math.max(0, Math.min(1, value));
        this.verticleSlider.setProgressValue(value);

        this.visibleElements = this._getVisibleElement();
      }
    }
  }

  /**
   * 增加一个 光标进入元素事件回调，回调参数为当前进入的元素对象
   * @param {*} value
   */
  addOnElementHoverEnterEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementHoverEnter.push(fun);
  }

  /**
   * 移除一个 光标进入元素事件回调
   * @param {*} fun
   */
  removeOnElementHoverEnterEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementHoverEnter.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementHoverEnter.splice(index, 1);
    }
  }

  /**
   * 移除所有 光标进入元素事件回调
   */
  removeAllOnElementHoverEnterEvent() {
    this._otherProps.onElementHoverEnter = [];
  }

  /**
   * 增加一个 光标离开元素事件回调，回调参数为当前离开的元素对象
   * @param {*} fun
   */
  addOnElementHoverExitEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementHoverExit.push(fun);
  }

  /**
   * 移除一个 光标离开元素事件回调
   * @param {*} fun
   */
  removeOnElementHoverExitEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementHoverExit.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementHoverExit.splice(index, 1);
    }
  }

  /**
   * 移除所有 光标离开元素事件回调
   */
  removeAllOnElementHoverExitEvent() {
    this._otherProps.onElementHoverExit = [];
  }

  /**
   * 增加一个 元素点击事件回调，回调参数为当前点击的树节点数据
   * @param {*} fun
   * @returns
   */
  addOnElementClickEvent(fun) {
    if (!fun) return;
    this._otherProps.onElementClick.push(fun);
  }

  /**
   * 移除一个 元素点击事件回调
   * @param {*} fun
   */
  removeOnElementClickEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onElementClick.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onElementClick.splice(index, 1);
    }
  }

  /**
   * 移除所有 元素点击事件回调
   */
  removeAllOnElementClickEvent() {
    this._otherProps.onElementClick = [];
  }

  /**
   * 增加一个树节点的显示隐藏按钮点击回调函数，回调函数参数为树节点数据和是否显示
   * @param {*} fun
   * @returns
   */
  addOnVisibleBtnClickEvent(fun) {
    if (!fun) return;
    this._otherProps.onVisibleBtnClick.push(fun);
  }

  /**
   * 移除一个 树节点的显示隐藏按钮点击回调函数
   * @param {*} fun
   * @returns
   */
  removeOnVisibleBtnClickEvent(fun) {
    if (!fun) return;
    let index = this._otherProps.onVisibleBtnClick.indexOf(fun);
    if (index >= 0) {
      this._otherProps.onVisibleBtnClick.splice(index, 1);
    }
  }

  /**
   * 移除所有 树节点的显示隐藏按钮点击回调函数
   */
  removeAllOnVisibleBtnClickEvent() {
    this._otherProps.onVisibleBtnClick = [];
  }

  /**
   * 设置树节点是否允许点击
   * @param {*} enable
   */
  setElementEnableClick(enable) {
    this.enableElementClick = enable;
  }
}
